import React from 'react'
import PropTypes from 'prop-types'

import Box from '@material-ui/core/Box'

import HotkeyMenuButton from './HotkeyMenuButton'
import HotkeySubMenuButton from './HotkeySubMenuButton'
import HotkeyProductButton from './HotkeyProductButton'
import HotkeySubheading from './HotkeySubheading'
import HotkeySpacer from './HotkeySpacer'
import HotkeyLineBreak from './HotkeyLineBreak'

import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  main: {
    backgroundColor: '#f8f8fa',
    width: 516 // this value is key to the grid working so be very careful changing it!!! - it needs to be the sum of 12 * elementWidth (currently 43)
  },
  empty: {
    height: 50,
    fontSize: 16,
    fontWeight: 400
  }
})

export default function HotkeyMenu (props) {
  const {
    elementData,
    onElementClick,
    onElementDoubleClick,
    selectedElement = null
  } = props

  const classes = useStyles()

  const elements = elementData.map((element) => {
    if (element.type === 'menu') {
      return (
        <HotkeyMenuButton
          key={element.id}
          id={element.id}
          width={element.widthValue}
          text={element.text}
          icon={element.icon}
          fontSize={element.fontSizeValue}
          onClick={(event, id) => onElementClick(event, id, element)}
          onDoubleClick={(event, id) => onElementDoubleClick(event, id, element)}
          selected={selectedElement !== null && selectedElement.id === element.id}
        />
      )
    } else if (element.type === 'submenu') {
      return (
        <HotkeySubMenuButton
          key={element.id}
          id={element.id}
          width={element.widthValue}
          text={element.text}
          fontSize={element.fontSizeValue}
          onClick={(event, id) => onElementClick(event, id, element)}
          onDoubleClick={(event, id) => onElementDoubleClick(event, id, element)}
          selected={selectedElement !== null && selectedElement.id === element.id}
        />
      )
    } else if (element.type === 'product') {
      return (
        <HotkeyProductButton
          key={element.id}
          id={element.id}
          width={element.widthValue}
          text={element.text}
          fontSize={element.fontSizeValue}
          color={element.color}
          price={element.price}
          itemSize={element.itemSize}
          ageRestriction={element.ageRestriction}
          productId={element.productId}
          onClick={(event, id) => onElementClick(event, id, element)}
          selected={selectedElement !== null && selectedElement.id === element.id}
        />
      )
    } else if (element.type === 'subheading') {
      return (
        <HotkeySubheading
          id={element.id}
          key={element.id}
          text={element.text}
          fontSize={element.fontSizeValue}
          onClick={(event, id) => onElementClick(event, id, element)}
          selected={selectedElement !== null && selectedElement.id === element.id}
        />
      )
    } else if (element.type === 'spacer') {
      return (
        <HotkeySpacer
          id={element.id}
          key={element.id}
          onClick={(event, id) => onElementClick(event, id, element)}
          selected={selectedElement !== null && selectedElement.id === element.id}
        />
      )
    } else if (element.type === 'linebreak') {
      return (
        <HotkeyLineBreak
          id={element.id}
          key={element.id}
          onClick={(event, id) => onElementClick(event, id, element)}
          selected={selectedElement !== null && selectedElement.id === element.id}
        />
      )
    } else {
      console.log('Invalid element type:', element)
    }
  })

  return (
    <Box className={classes.main} position="relative" display="flex" flexWrap="wrap">
      {
        elements.length > 0
          ? elements
          : <Box className={classes.empty} flex={1} display="flex" justifyContent="center" alignItems="center">
            Menu is currently empty
          </Box>
      }
    </Box>
  )
}

HotkeyMenu.propTypes = {
  elementData: PropTypes.array.isRequired,
  onElementClick: PropTypes.func.isRequired,
  onElementDoubleClick: PropTypes.func,
  selectedElement: PropTypes.object
}
